
import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BalanceDetail = ({ Muldata }) => {


  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);
  const { BalDetailData } = useSelector((state) => state.PartyProfileSlice);

  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "MonthName", label: "Month", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "InwardDate", label: "InwardDate", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ShortAcName", label: "Party Marka", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "LotNo", label: "Lot. No.", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Itemname", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Taka", label: "Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "BalanceTaka", label: "Balance Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "BalanceMeter", label: "Balance Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];


  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: " 14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px",fontWeight:"700" }}>
                    MERGING
                  </h2>
                </div>
                {BalDetailData?.BalDate &&
                  BalDetailData?.BalDate?.length > 0 &&
                  BalDetailData?.BalDate?.some((row) =>
                    Object.values(row).some(
                      (value) => value !== "-" && value !== "" && value !== null
                    )
                  ) ? (
                  <GreyTable
                    columns={columns}
                    data={BalDetailData?.BalDate?.map((row, index, arr) => {
                      const totalLength = arr.length.toString().length;
                      return {
                        id: index,
                        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
                        ...row,
                        InwardDate: new Date(row.InwardDate).toLocaleDateString(
                          "en-GB"
                        ),
                        LotNo: row.LotNo,
                        Taka: row.Taka,
                        BalanceTaka: row.BalanceTaka,
                        BalanceMeter: row.BalanceMeter,
                      };
                    })}
                    iscolourDark={iscolourDark}
                    iscolour={iscolour}
                  />
                ) : (
                  <p
                    style={{
                      color: "#ff0000",
                      fontWeight: "bold",
                      padding: "10px",
                    }}
                  >
                    Data Not Found
                  </p>
                )}
              </div>
            </>


            {Muldata?.map((el) => {
              return (
                <>
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px" }}>
                        {AccountToPGroupListData?.Data?.find(
                          (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                        )?.ProductionGroupMstName || `Group ${el.group}`}
                      </h2>
                    </div>

                    {el?.BalDate &&
                      el?.BalDate?.length > 0 &&
                      el?.BalDate?.some((row) =>
                        Object.values(row).some(
                          (value) => value !== "-" && value !== "" && value !== null
                        )
                      ) ? (
                      <GreyTable
                        columns={columns}
                        data={el?.BalDate?.map((row, index, arr) => {
                          const totalLength = arr.length.toString().length;
                          return {
                            id: index,
                            srNumber: (index + 1)
                              .toString()
                              .padStart(totalLength, "0"),
                            ...row,
                            InwardDate: new Date(row.InwardDate).toLocaleDateString(
                              "en-GB"
                            ),
                            LotNo: row.LotNo,
                            Taka: row.Taka,
                            BalanceTaka: row.BalanceTaka,
                            BalanceMeter: row.BalanceMeter,
                          };
                        })}
                        iscolourDark={iscolourDark}
                        iscolour={iscolour}
                      />
                    ) : (
                      <p
                        style={{
                          color: "#ff0000",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Data Not Found
                      </p>
                    )}
                  </div>
                </>
              );
            })}
          </Col >
        </Row>
      </div>
    </>
  )
}


